import classes from './ToastMessage.module.css'
import { useEffect } from 'react'

const ToastMessage = ({ text, color, close }) => {

    useEffect(() => {
        setTimeout(() => {
            close(null)
        }, 2800)
    }, [])
    
    return (
        <div>
            <div className={classes.ToastMessageSupport} style={{ backgroundColor: `${color}` }}>
                <div>{text}</div>
            </div>
        </div>
    )
}
export default ToastMessage;